'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isErrorAction = undefined;

var _errorActionGetters = require('./errorActionGetters');

var ERROR_ACTION_REGEX = /.+_(FAILED|FAILURE)/;

var isErrorAction = exports.isErrorAction = function isErrorAction(action) {
  if (ERROR_ACTION_REGEX.test(action.type) && !(0, _errorActionGetters.ignoreError)(action)) {
    return true;
  }

  if ((0, _errorActionGetters.getErrorMeta)(action) && !(0, _errorActionGetters.ignoreError)(action)) {
    return true;
  }

  return false;
};